<template>
    <div>
        <modal-new-competition></modal-new-competition>



        <div class="content-wrapper" v-if="!loadingComplete()">
            <section class="content">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header">
                            <h3 class="box-title">Chargement en cours</h3>
                        </div>
                        <div class="box-body">
                            Chargement de la competition
                        </div>
                        <div class="overlay">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="content-wrapper" v-if="loadingComplete()">
            <!-- Content Header (Page header) -->
            <section class="content-header" v-if="competition_id!=0">
                <h1>
                    {{getCompetition.competition}}
                    <small> # {{getCompetition.participations.length}} compétiteurs</small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li><a href="#">Compétitions</a></li>
                    <li class="active"><a href="#">#{{getCompetition.competition}}</a></li>
                </ol>
            </section>

            <section class="content-header" v-if="competition_id==0">
                <h1>
                    Compétitions
                    <small></small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li class="active"><a href="#">Compétitions</a></li>
                </ol>
            </section>

            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="nav-tabs-custom nav-tabs-custom-bottom">
                            <ul class="nav nav-tabs" role="tablist">
                                <li :class="{ 'active': competition_id!=0 }" v-if="competition_id!=0">
                                    <a href="#member_tab_1"
                                       aria-controls="#member_tab_1"
                                       data-toggle="tab"
                                       aria-expanded="false">Fiche de la competition</a>
                                </li>

                                <li :class="" v-if="competition_id!=0">
                                    <a href="#member_tab_2"
                                       aria-controls="#member_tab_2"
                                       data-toggle="tab"
                                       aria-expanded="false">Competiteurs et résultats</a>
                                </li>
                                <li :class="" v-if="competition_id!=0">
                                    <a href="#member_tab_3"
                                       aria-controls="#member_tab_2"
                                       data-toggle="tab"
                                       aria-expanded="false">Arbitres</a>
                                </li>

                                <li :class="{ 'active': competition_id==0 }">
                                    <a href="#member_tab_4"
                                       aria-controls="#member_tab_4"
                                       data-toggle="tab"
                                       aria-expanded="false">Listing des competitions</a>
                                </li>

                                <li class="pull-right">
                                    <a @click.prevent="showModalNewCompetition()">Ajouter une competition</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row tab-content">
                    <div v-if="competition_id!=0" role="tabpanel" class="col-md-12 tab-pane"
                         :class="{ 'active': competition_id!=0 }" id="member_tab_1">
                        <MainFormCompetition
                                v-if="competition_id!=0"
                                :loadingTableMembres="loading"
                                @onNeedRefreshCompetition="refreshCompetition()"
                        ></MainFormCompetition>
                    </div>
                    <div v-if="competition_id!=0" role="tabpanel" class="col-md-12 tab-pane"
                         :class="" id="member_tab_2">
                        <InscriptionsResultats
                        v-if="competition_id!=0"
                        ></InscriptionsResultats>
                    </div>
                    <div v-if="competition_id!=0" role="tabpanel" class="col-md-12 tab-pane"
                         :class="" id="member_tab_3">
                        <InscriptionsArbitres
                        v-if="competition_id!=0"
                        ></InscriptionsArbitres>
                    </div>

                    <div role="tabpanel" class="col-md-12 tab-pane" :class="{ 'active': competition_id==0 }" id="member_tab_4">
                        <ListingCompetition>
                        </ListingCompetition>
                    </div>

                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MainFormCompetition from './MainFormCompetition.vue'
    import ModalNewCompetition from './ModalNewCompetition'
    import ListingCompetition from './ListingCompetition'
    import InscriptionsResultats from "./InscriptionsResultats";
    import InscriptionsArbitres from "./InscriptionsArbitres";

    export default {
        data() {
            return {

                loading: false,
                competition_id: null
            }
        },
        props: {},
        computed: {
            ...mapGetters({
                getCompetition: 'getCompetition',
                getNiveauxCompetition: 'getNiveauxCompetition',
                getRoute: 'getRoute',
                getCategAge: 'getCategAge',
                getCategGrade: 'getCategGrade',
                getCategPoids: 'getCategPoids',
            })
        },
        methods: {
            ...mapActions({
                setCompetition: 'setCompetition',
                setNiveauxCompetition: 'setNiveauxCompetition',
                setListeCompetition: 'setListeCompetition',
                setCategAge: 'setCategAge',
                setCategGrade: 'setCategGrade',
                setCategPoids: 'setCategPoids',
            }),

            showModalNewCompetition: function () {
                $('#modalNewCompetition').modal()
            },
            refreshCompetition: function () {
                return this.loadCompetition();
            },
            loadingComplete: function () {
                return this.competition_id == 0 ? true :
                    (this.getCompetition != null && this.getNiveauxCompetition != null)
            },
            loadNiveauxCompetition: function () {
                this.$http.get(this.getRoute('getAllNiveauxCompetition')).then((response) => {
                    this.setNiveauxCompetition(response.body)
                }, (response) => {
                });
            },
            loadCategAgeCompetition: function () {
                this.$http.get(this.getRoute('getAllAgeCompetition')).then((response) => {
                    this.setCategAge(response.body)
                }, (response) => {
                });
            },
            loadCategPoidsCompetition: function () {
                this.$http.get(this.getRoute('getAllPoidsCompetition')).then((response) => {
                    this.setCategPoids(response.body)
                }, (response) => {
                });
            },
            loadCategGradeCompetition: function () {
                this.$http.get(this.getRoute('getAllGradeCompetition')).then((response) => {
                    this.setCategGrade(response.body)
                }, (response) => {
                });
            },
            loadListeCompetition: function () {
                this.$http.get(this.getRoute('getAllCompetitions')).then((response) => {
                    this.setListeCompetition(response.body)
                }, (response) => {
                });
            },
            loadCompetition: function () {
                this.loading = true
                if (this.competition_id == 0)
                    return;
                this.$http.get(this.getRoute('Secretariat.getInfosCompetition') + this.competition_id)
                    .then((response) => {
                        this.setCompetition(response.body)
                        this.loading = false
                    }, (response) => {
                        this.loading = false
                        this.setCompetition(null)
                    });
            },
        },
        beforeRouteUpdate(to, from, next) {
            this.competition_id = to.params.competition_id;
            // console.log("Update to " + this.competition_id)
            this.setCompetition(null)
            this.loadNiveauxCompetition()
            this.loadListeCompetition()
            this.loadCompetition()
            this.loadCategAgeCompetition()
            this.loadCategPoidsCompetition()
            this.loadCategGradeCompetition()
            next()

        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.competition_id = vm.$route.params.competition_id
                vm.setCompetition(null)
                vm.loadNiveauxCompetition()
                vm.loadListeCompetition()
                vm.loadCompetition()
                vm.loadCategAgeCompetition()
                vm.loadCategPoidsCompetition()
                vm.loadCategGradeCompetition()
            })
        },
        watch: {},
        components: {
            InscriptionsArbitres,
            InscriptionsResultats,
            MainFormCompetition,
            ModalNewCompetition,
            ListingCompetition,
            InscriptionsResultats,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Competition/AppCompetition.vue